import React, { useEffect, useState } from 'react'
import {
    Card,
    Space,
    Typography
} from 'antd'
import { CrownOutlined } from '@ant-design/icons'
import { useDataUsuarioSelected } from '../../../../Hooks/Admin/useContextos';
import { camposFormulario, camposFormularioCrear, columns } from './Helpers/listarLogrosHelper';
import { CustomTable } from '../../../../Components/Admin/CustomTable';
import { useListarLogrosUsuarioTable, useObtenerlogro, useSelectLogros, useTipoLogroSelect, useEliminarLogroUsuario } from '../queries/querysUsuario';

const { Title, Text } = Typography;

export const LogrosUsuario = () => {
    const { selectedId } = useDataUsuarioSelected();
    const [logrosSelect, setLogrosSelect] = useState([]);
    const [tiposLogroFiltro, setTiposLogroFiltro] = useState([]);

    const tiposLogro = useTipoLogroSelect();
    const queryLogros = useSelectLogros({ idUsuario: selectedId });

    useEffect(() => {
        if (selectedId && queryLogros.isSuccess) {
            setLogrosSelect(queryLogros.data ?? []);
        }
    }, [selectedId, queryLogros.isSuccess, queryLogros.data]);

    useEffect(() => {
        if (tiposLogro.data) {
            setTiposLogroFiltro(tiposLogro.data);
        }
    }, [tiposLogro.data]);

    return (
        <>
            {selectedId ? (
                <Card 
                    title={
                        <Space>
                            <CrownOutlined style={{ color: '#faad14' }} />
                            <span>Logros del Usuario</span>
                        </Space>
                    } 
                    style={{ 
                        borderRadius: '12px',
                        border: '1px solid #f0f0f0',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                    }}
                >
                    <CustomTable
                        queryListar={useListarLogrosUsuarioTable}
                        columns={columns()}
                        editable={false}
                        perPage={10}
                        basicParams={{ idUsuario: selectedId, page: 1, perPage: 10 }}
                        camposFilter={camposFormulario(tiposLogroFiltro)}
                        camposAgregar={camposFormularioCrear(logrosSelect, selectedId)}
                        queryCrear={useObtenerlogro}
                        canDelete={true}
                        queryBorrarFila={useEliminarLogroUsuario}
                        tituloTabla="Gestión de Logros del Usuario"
                    />
                </Card>
            ) : (
                <Card 
                    style={{ 
                        textAlign: 'center',
                        padding: '60px 20px',
                        borderRadius: '12px',
                        border: '2px dashed #d9d9d9',
                        background: '#fafafa'
                    }}
                >
                    <Space direction="vertical" size="large">
                        <CrownOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />
                        <div>
                            <Title level={3} style={{ color: '#8c8c8c' }}>
                                Selecciona un usuario
                            </Title>
                            <Text style={{ color: '#8c8c8c' }}>
                                Elige un usuario de la lista para gestionar sus logros
                            </Text>
                        </div>
                    </Space>
                </Card>
            )}
        </>
    )
}
